import script from "./PageToolbarActionsDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageToolbarActionsDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./PageToolbarActionsDropdown.vue?vue&type=style&index=0&id=5221a492&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5221a492"]])

export default __exports__